import { Task } from "../../components/planning/weekCalendrier";

export const getFirstDayOfMonth = (date: Date) => {
    const firstDay = new Date(Date.UTC(date.getFullYear(), date.getMonth(), 1));
    return firstDay.toISOString();
}

export const getLastDayOfMonth = (date: Date) => {
    const lastDay = new Date(Date.UTC(date.getFullYear(), date.getMonth() + 1, 0, 23, 59, 59, 999));
    return lastDay.toISOString();
}

export const getStartOfWeek = (date: Date) => {
    const start = new Date(date);
    const day = start.getDay();
    const diff = start.getDate() - day + (day === 0 ? -6 : 1);
    return new Date(start.setDate(diff));
}


export const getEndOfWeek = (date: Date): Date => {
    const end = new Date(date);
    const day = end.getDay();
    const diff = end.getDate() + (7 - day) - (day === 0 ? 7 : 0); // Adjust if day is Sunday
    end.setDate(diff);
    end.setHours(23, 59, 59, 999);
    return end;
};
export const formatDate = (date: Date) => {
    return date.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit' });
}

export const sortTasksByTime = (tasks: Task[]) => {
    return tasks?.sort((a, b) => new Date(a.start).getTime() - new Date(b.start).getTime());
}
export const getDaysInMonth = (year: number, month: number): Date[] => {
    const days = [];
    const date = new Date(year, month, 1);
    while (date.getMonth() === month) {
        days.push(new Date(date));
        date.setDate(date.getDate() + 1);
    }
    return days;
};

